import { SlideAction, SlideLayout, ViewMode } from '@gripp/shared-ui';
import { useNavigate } from 'react-router-dom';
import { ActivityEditColumn } from './activityEditColumn';
import { ActivityReviseColumn } from './activityReviseColumn';

export const ActivityRevise = () => {
  const navigate = useNavigate();
  
  const leftColumn = {
    title: 'issue.menu.edit',
    mainComponent: <ActivityEditColumn />,
    showBackButton: true,
    onBackButtonPress: () => navigate('../..', { relative: 'path', state: { skipAutoSelect: true } }),
    backButtonTransition: SlideAction.PREV,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'issue.editModal.reviseSubmission',
    mainComponent: <ActivityReviseColumn />,
    showBackButton: true,
    onBackButtonPress: () => navigate('..', { relative: 'path' }),
    backButtonTransition: SlideAction.PREV,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
